<template>
  <div class="app-radio-group" :class="layout">
    <AppInputRadio
      v-on="$listeners"
      v-for="option in options"
      type="radio"
      v-model="option.value"
      :key="option.value"
      :label="option.label"
      :name="name"
      :checked="checkedValue === option.value"
    />
  </div>
</template>

<script>
// Components
import AppInputRadio from 'Ui/AppInputRadio'

export default {
  name: 'AppRadioGroup',

  components: {
    AppInputRadio,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    checkedValue: {
      type: [String, Number],
      required: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    layout() {
      return this.vertical ? 'row' : 'column'
    },
  },
}
</script>

<style scoped>
.app-radio-group {
  display: grid;
  grid-gap: 8px;
}

.app-radio-group.column {
  grid-template-columns: repeat(auto-fit, minmax(20px, 1fr));
}
</style>
